import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { Capacity } from '../models/capacity';

/**
 * Base url for api
 */
 const BASE_URL = 'capacity';

 @Injectable({
   providedIn: 'root'
 })
 
 /**
  * Capacity Service
  */
 export class CapacityService {
 
   /**
    * Is loading
    */
   public loading$: Observable<boolean>;
 
   /**
    * Constructor
    *
    * @param apiService ApiService
    * @param httpClient HttpClient
    * @param authenticationService AuthenticationService
    */
   constructor(private apiService: ApiService) {
     this.loading$ = this.apiService.loading$;
   }
   /**
    * Create
    *
    * @param capacity Department instance
    */
   create(capacity: Capacity): Observable<any> {
     return this.apiService.post(BASE_URL, capacity);
   }
 
   /**
    * Update
    * @param capacity Capacity instance
    */
   update(capacity: Capacity): Observable<any> {
     const id = capacity.id;
     delete capacity.id;
     return this.apiService.patch(`${BASE_URL}/${id}`, capacity);
   }
 
   /**
    * Delete
    *
    * @param id Primary key
    */
   delete(id: number): Observable<any> {
     return this.apiService.delete(`${BASE_URL}/${id}`);
   }
 
   /**
    * Find filtered
    *
    * @param queryOptions Object with query options
    */
   findFiltered(queryOptions): Observable<Capacity[]> {
     return this.apiService.post(`${BASE_URL}/list`, queryOptions).pipe(map(
       capacities => capacities.map(
         (capacity) => Capacity.createFromJson(capacity))
       )
     );
   }
 
   /**
    * List capacity
    */
   list(): Observable<Capacity[]> {
     return this.apiService
       .get(`${BASE_URL}/list`)
       .pipe(map(
         capacities => capacities.map(
           (capacity) => Capacity.createFromJson(capacity))
         )
       );
   }
 
   /**
    * Get count for filter
    *
    * @param order Order
    * @param sort Sort
    * @param limit Limit
    * @param page Page
    * @param filter Filter object
    */

  // tslint:disable-next-line:max-line-length
  getCount(order: string = 'id', sort: string = 'asc', limit: number = 5, page: number = 0, filter: object = {}): Observable<any> {
    const options = {order, sort, limit, page};

    return this.apiService.post(`${BASE_URL}/count`, {...options, ...filter});
  }

}
